import { render } from "./Development.vue?vue&type=template&id=681e3049"
import script from "./Development.vue?vue&type=script&lang=js"
export * from "./Development.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Development.vue?vue&type=style&index=0&id=681e3049&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__